import { Handle, Position } from '@xyflow/react';
import { type ConnectorType } from '@models/flows';

import s from './ConnectionPoint.module.css';

type Props = {
  id: string;
  type: ConnectorType;
  position: Position;
  customClass?: string;
};

function ConnectionPoint({ id, type, position, customClass }: Props) {
  return (
    <Handle id={id} type={type} position={position} className={`${s.node} ${customClass || ''}`} />
  );
}

export default ConnectionPoint;
